import 'slick-carousel/slick/slick';
import 'slick-lightbox-latest/dist/slick-lightbox.min';
import gtag_event from './gtag-init';

jQuery(function ($) {

  const LEADS_FORM_WIDGET = '.elementor-widget-wa_leads_form';

  var current_modal = null;
  var btn_brochure = null;
  var btn_whatsapp = null;

  $(document).on('click', '.btn-unit-type-modal', function () {
    $(LEADS_FORM_WIDGET).addClass('modal-open');

    current_modal = $(this).attr('data-target');
    btn_whatsapp = document.querySelector(current_modal + ' div.modal-footer .btn-whatsapp');
    btn_brochure = document.querySelector(current_modal + ' div.modal-footer .btn-download-brochure');

    let _img_slider = JSON.parse($(this).attr('data-slider'));
    let _title = $(this).attr('data-title');
    let _price_title = $(this).attr('data-price-title');
    let _price = $(this).attr('data-price');
    let _price_color = $(this).attr('data-price-color');
    let _detail_title = $(this).attr('data-detail-title');
    let _detail_icon_color = $(this).attr('data-icon-color')
    let _detail_bedroom_title = $(this).attr('data-bedroom-title');
    let _detail_bedroom_value = $(this).attr('data-bedroom-value');
    let _detail_bathroom_title = $(this).attr('data-bathroom-title');
    let _detail_bathroom_value = $(this).attr('data-bathroom-value');
    let _detail_carport_title = $(this).attr('data-carport-title');
    let _detail_carport_value = $(this).attr('data-carport-value');
    let _detail_landsize_title = $(this).attr('data-landsize-title');
    let _detail_landsize_value = $(this).attr('data-landsize-value');
    let _detail_buildingsize_title = $(this).attr('data-buildingsize-title');
    let _detail_buildingsize_value = $(this).attr('data-buildingsize-value');
    let _description_title = $(this).attr('data-description-title');
    let _description_body = $(this).attr('data-description');
    let _btn_brochure_text = $(this).attr('data-btn-brochure-text');
    let _btn_brochure_color = $(this).attr('data-btn-brochure-color');
    let _btn_brochure_border_color = $(this).attr('data-btn-brochure-border-color');
    let _btn_brochure_text_color = $(this).attr('data-btn-brochure-text-color');
    let _btn_wa_text = $(this).attr('data-btn-wa-text');
    let _btn_wa_color = $(this).attr('data-btn-wa-color');
    let _btn_wa_border_color = $(this).attr('data-btn-wa-border-color');
    let _btn_wa_text_color = $(this).attr('data-btn-wa-text-color');

    $(current_modal + ' #unit-type-modal-label h4').text(_title);
    $(current_modal + ' .modal-title h4').text(_title);
    $(current_modal + ' .unit-label').text(_title);
    $(current_modal + ' .price-installment div:first-child').text(_price_title);
    $(current_modal + ' .price-installment div.price').text(_price);
    $(current_modal + ' .detail-unit-title').text(_detail_title);
    $(current_modal + ' .bedroom .label-modal').text(_detail_bedroom_title);
    $(current_modal + ' .bedroom .value').text(_detail_bedroom_value);
    $(current_modal + ' .bathroom .label-modal').text(_detail_bathroom_title);
    $(current_modal + ' .bathroom .value').text(_detail_bathroom_value);
    $(current_modal + ' .carport .label-modal').text(_detail_carport_title);
    $(current_modal + ' .carport .value').text(_detail_carport_value);
    $(current_modal + ' .landsize .label-modal').text(_detail_landsize_title);
    $(current_modal + ' .landsize .value').text(_detail_landsize_value);
    $(current_modal + ' .buildingsize .label-modal').text(_detail_buildingsize_title);
    $(current_modal + ' .buildingsize .value').text(_detail_buildingsize_value);
    $(current_modal + ' .description h4').text(_description_title);
    $(current_modal + ' .description div.col').html(_description_body);
    $(current_modal + ' .modal-footer .btn-download-brochure span.label').text(_btn_brochure_text);
    $(current_modal + ' .modal-footer .btn-whatsapp span.label').text(_btn_wa_text);

    let price = document.querySelector(current_modal + ' .unit-detail-wrap .price');
    let detail_icon_svg = document.querySelectorAll(current_modal + ' .info-line > svg > path');
    let btn_brochure_svg = document.querySelectorAll(current_modal + ' div.modal-footer .btn-download-brochure svg > path');

    price.style.color = _price_color;
    detail_icon_svg.forEach(function(svg) {
      svg.style.fill = _detail_icon_color;
    });
    btn_whatsapp.style.color = _btn_wa_text_color;
    btn_whatsapp.style.borderColor = _btn_wa_border_color;
    btn_whatsapp.style.backgroundColor = _btn_wa_color;
    btn_brochure.style.color = _btn_brochure_text_color;
    btn_brochure.style.borderColor = _btn_brochure_border_color;
    btn_brochure.style.backgroundColor = _btn_brochure_color;
    btn_brochure_svg.forEach(function(svg) {
      svg.style.fill = _btn_brochure_text_color;
    });

    const att_title_whatsapp = document.createAttribute('data-title');
    const att_description_whatsapp = document.createAttribute('data-description');
    const att_submit_whatsapp = document.createAttribute('data-submit');
    const att_submit_leads_color_whatsapp = document.createAttribute('data-submit-leads-color');
    const att_submit_leads_background_whatsapp = document.createAttribute('data-submit-leads-background');
    const att_cover_whatsapp = document.createAttribute('data-cover');

    const att_title_brochure = document.createAttribute('data-title');
    const att_url_brochure = document.createAttribute('href');
    const att_description_brochure = document.createAttribute('data-description');
    const att_submit_brochure = document.createAttribute('data-submit');
    const att_submit_leads_color_brochure = document.createAttribute('data-submit-leads-color');
    const att_submit_leads_background_brochure = document.createAttribute('data-submit-leads-background');
    const att_cover_brochure = document.createAttribute('data-cover');

    att_title_whatsapp.value = $(this).attr('data-title-wa');
    att_description_whatsapp.value = $(this).attr('data-description-wa');
    att_submit_whatsapp.value = $(this).attr('data-submit-wa');
    att_submit_leads_color_whatsapp.value = $(this).attr('data-submit-leads-color-wa');
    att_submit_leads_background_whatsapp.value = $(this).attr('data-submit-leads-background-wa');
    att_cover_whatsapp.value = $(this).attr('data-cover-wa');

    att_title_brochure.value = $(this).attr('data-title-brochure');
    att_url_brochure.value = $(this).attr('data-url-brochure');
    att_description_brochure.value = $(this).attr('data-description-brochure');
    att_submit_brochure.value = $(this).attr('data-submit-brochure');
    att_submit_leads_color_brochure.value = $(this).attr('data-submit-leads-color-brochure');
    att_submit_leads_background_brochure.value = $(this).attr('data-submit-leads-background-brochure');
    att_cover_brochure.value = $(this).attr('data-cover-brochure');

    btn_brochure.setAttributeNode(att_title_brochure);
    btn_brochure.setAttributeNode(att_url_brochure);
    btn_brochure.setAttributeNode(att_description_brochure);
    btn_brochure.setAttributeNode(att_submit_brochure);
    btn_brochure.setAttributeNode(att_submit_leads_color_brochure);
    btn_brochure.setAttributeNode(att_submit_leads_background_brochure);
    btn_brochure.setAttributeNode(att_cover_brochure);

    btn_whatsapp.setAttributeNode(att_title_whatsapp);
    btn_whatsapp.setAttributeNode(att_description_whatsapp);
    btn_whatsapp.setAttributeNode(att_submit_whatsapp);
    btn_whatsapp.setAttributeNode(att_submit_leads_color_whatsapp);
    btn_whatsapp.setAttributeNode(att_submit_leads_background_whatsapp);
    btn_whatsapp.setAttributeNode(att_cover_whatsapp);

    btn_brochure.addEventListener('click', hideParentModal);
    btn_whatsapp.addEventListener('click', hideParentModal);

    if(_img_slider.length > 0) {
      $(current_modal + ' .unit-type-slider').show();
 
      if(_img_slider.length > 1) {

        _img_slider.forEach(function(img_slider) {
          $(current_modal + ' .unit-type-slider').append('<img class="img-slide-detail w-100 h-360px border-radius-8px " src=' + img_slider + '>');
        });
        setSlider();

      } else {
        $(current_modal + ' .unit-type-slider').append('<img class="img-slide-detail w-100 h-360px border-radius-8px " src=' + _img_slider + '>');
      }

    } else {
      $(current_modal + ' .unit-type-slider').hide();
    }

    $(current_modal).on('hidden.bs.modal', () => {
      clearSlider();
    });
  });

  $(LEADS_FORM_WIDGET + ' .modal').on('hidden.bs.modal', () => {
    clearModal();
  });

  function hideParentModal() {
    $(current_modal).modal('hide');
  }

  function clearModal() {
    $(LEADS_FORM_WIDGET).removeClass('modal-open');
  }
 
  function setSlider() {
    $(current_modal + ' .unit-type-slider').slick({
      mobileFirst: true,
      dots: true,
      infinite: false,
      speed: 300,
      slidesToShow: 1,
      prevArrow: '<button type="button" class="btn btn-sm btn-arrow btn-prev"><svg width="14" height="24" viewBox="0 0 14 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M4.66019e-07 12C4.7928e-07 11.6737 0.13069 11.3474 0.392071 11.0986L12.0514 -8.90479e-08L13.9453 1.80286L3.23298 12L13.9453 22.1971L12.0514 24L0.392071 12.9014C0.13069 12.6526 4.52759e-07 12.3263 4.66019e-07 12Z" fill="#fafafa"/></svg></button>',
      nextArrow: '<button type="button" class="btn btn-sm btn-arrow btn-next"><svg width="14" height="24" viewBox="0 0 14 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M14 12C14 11.6737 13.8693 11.3474 13.6079 11.0986L1.94863 -8.90479e-08L0.0546876 1.80286L10.767 12L0.0546884 22.1971L1.94863 24L13.6079 12.9014C13.8693 12.6526 14 12.3263 14 12Z" fill="#fafafa"/></svg></button>',
    });
    $(current_modal + ' .unit-type-slider').slick('refresh');
  }

  function clearSlider() {
    $(current_modal + ' .unit-type-slider').find('*').remove();
    $(current_modal + ' .unit-type-slider').slick('unslick');
  }

  $(function() {
    // unit type widget button clicked
    $('.elementor-button-wrapper .btn-unit-type-modal').on('click', function() {
      let unitName = $(this).data('title');
      gtag_event('Detail Unit Button Clicked', unitName);
    });

  });
  // ------------------!> The End of Event Tracker

});



// WEBPACK FOOTER //
// ./scripts/custom-elementor-widget/unit-type-modal.js